import { Box, Divider as UclDivider } from '@rbilabs/universal-components';

export const Divider = UclDivider.withConfig({
  marginY: '$4',
  orientation: 'horizontal',
  thickness: '1',
});

/*
 * this duplicates the amount of spacing around an ActionLink
 * so that the loading indicator can transition to an ActionLink
 * without elements around it shifting on the page
 */
export const NeedHelpButtonLoadingIndicatorWrapper = Box.withConfig({
  padding: '$3',
  borderWidth: 1,
  borderColor: 'transparent',
});
